// Official PGMBM WhatsApp channel for Co-Counsels. Single source of truth for the
// floating contact button; user-facing copy lives in language_{pt,en}.json under "whatsapp".
export const WHATSAPP_CONTACT = {
  displayNumber: "+55 33 99981-6149",
  waNumber: "5533999816149",
  baseUrl: "https://wa.me",
  hours: { days: "MON-FRI", start: "09:00", end: "13:00", timeZone: "America/Sao_Paulo" },
};

/**
 * Prefilled message: never includes client data, only the user's identity and,
 * when known, the matter number currently open.
 * `template` comes from i18n ("whatsapp.prefill" / "whatsapp.prefillMatter").
 */
export const buildWhatsAppMessage = ({ template, matterTemplate, name, cocoCode, matterNumber }) => {
  const identity = String(name || "").trim();
  const code = String(cocoCode || "").trim();
  let text = template
    .replace("{name}", identity)
    .replace(" {cocoCode}", code ? ` ${code}` : "")
    .replace("{cocoCode}", code);
  const matter = String(matterNumber || "").trim();
  if (matter && matterTemplate) text = `${text}${matterTemplate.replace("{matter}", matter)}`;
  return text;
};

export const buildWhatsAppUrl = (message, contact = WHATSAPP_CONTACT) =>
  `${contact.baseUrl}/${contact.waNumber}?text=${encodeURIComponent(message)}`;

export const WHATSAPP_CHAT_URL = `${WHATSAPP_CONTACT.baseUrl}/${WHATSAPP_CONTACT.waNumber}`;
